import React, { Component } from "react";
import PropTypes from "prop-types";
import { Typography } from "material-ui";
import moment from "moment-with-locales-es6";
import { withStylesAndTranslation } from "../utils/container";

const styleSheet = theme => ({});

let callbacks = [];
setInterval(() => {
    callbacks.forEach(c => c());
}, 45 * 1000);

class TimeFromNow extends Component {
    static propTypes = {
        className: PropTypes.string,
        classes: PropTypes.object,
        date: PropTypes.object
    };

    static defaultProps = {
        date: new Date()
    };

    state = {
        formattedDate: null
    };

    updateState = () => {
        const { date } = this.props;
        const formattedDate = moment(date).fromNow();
        if (this.state.formattedDate !== formattedDate) {
            this.setState({ formattedDate });
        }
    };

    componentWillMount() {
        callbacks.push(this.updateState);
    }

    componentWillUnmount() {
        callbacks = callbacks.filter(c => this.updateState !== c);
    }

    render() {
        const { date } = this.props;
        return (
            <Typography type="body1" color="secondary" component="div">
                {moment(date).fromNow()}
            </Typography>
        );
    }
}

export default withStylesAndTranslation(TimeFromNow, styleSheet);



// WEBPACK FOOTER //
// ./src/components/TimeFromNow.jsx